var __jsx = React.createElement;
/* eslint-disable no-console */
import React, { Fragment, useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import { ThemeProvider } from 'styled-components';
import themes from '../themes';
import objectFitPolyfill from 'objectFitPolyfill';
import { convertPhoneFormat, triggerWindowResize, pencilUrlParseSite } from '../utils/utilityFunction';
import { googleTagManager } from '../constants/globalConstants';
import analyticsConstants from '../constants/analyticsConstants';
import { navLabels } from '../constants/labels/en/label';
import { toLower, GTMsrc, getLanguageAndLocation, getSocialForAnalytics, extractTwitterHandle } from '../utils/utilityFunction';
import { LocalBusinessJsonLd } from 'next-seo';
import Head from 'next/head';
import { getUrl } from '../../internal/utils/router';
import dynamic from 'next/dynamic';
import HeaderWrapper from '../components/organisms/HeaderWrapper';
import FooterV2 from '../components/organisms/FooterV2';
import GlobalFooter from '../components/organisms/GlobalFooter';
import Para from '../components/atoms/Para';
import Alert from '../components/organisms/Alert/Alert';
import Anchor from '../components/atoms/Anchor';
import PencilBanner from '../components/organisms/PencilBanner';
import { Context } from '../global-state-context';
import Banner from '../components/organisms/Banner';

// TODO: This should be moved to a real router
var formatCanonical = function formatCanonical(siteData, pagePath) {
  if (siteData && siteData.url && pagePath) {
    var segments = pagePath;
    //correct double slashes from page path
    while (segments.slice(0, 2) === '//') {
      segments = segments.substr(1);
    }
    return getUrl({
      domain: siteData.url,
      segments: [segments]
    });
  }
  return '';
};
var Layout = function Layout(_ref) {
  var _headerAnalytics$anal, _globalFooterData$soc, _site$locationContact, _site$websiteName, _site$websiteName2, _site$locationContact2, _site$locationContact3, _document, _yextContactInformati, _yextContactInformati2, _yextContactInformati3, _yextContactInformati4, _yextContactInformati5, _site$logoDark, _site$logoLight, _process, _process$env;
  var children = _ref.children,
    globalHeaderData = _ref.globalHeaderData,
    globalFooterData = _ref.globalFooterData,
    globalFooterDataPS = _ref.globalFooterDataPS,
    nvaFooterData = _ref.nvaFooterData,
    contentfulAlertData = _ref.contentfulAlertData,
    siteData = _ref.siteData,
    yextContactInformationData = _ref.yextContactInformationData,
    pageTitle = _ref.pageTitle,
    pageDescription = _ref.pageDescription,
    robotsTag = _ref.robotsTag,
    path = _ref.pagePath,
    isfooterWithoutForm = _ref.isfooterWithoutForm,
    removeHeader = _ref.removeHeader,
    removeFooter = _ref.removeFooter,
    doNotCrawl = _ref.doNotCrawl,
    ogImage = _ref.ogImage;
  var _useContext = useContext(Context),
    yextDivision = _useContext.yextDivision,
    yextLocationCountry = _useContext.yextLocationCountry,
    dynamicStylesCss = _useContext.dynamicStylesCss,
    websiteName = _useContext.websiteName;
  var correctedPath = correctPath(path);
  var pagePath = correctedPath = correctedPath == '/undefined' ? '/' : "/".concat(correctedPath);
  var canonicalPagePath = formatCanonical(siteData, pagePath);
  var googleTagList = [];
  var newtheme = siteData && siteData.theme || 'ModernV1';
  var site = siteData && siteData;
  var headerAnalytics = analyticsConstants.globalHeader;
  var showBannerV2 = (site === null || site === void 0 ? void 0 : site.showEmergencyBanner) && !(globalHeaderData !== null && globalHeaderData !== void 0 && globalHeaderData.enableHeaderOverlay) && (site === null || site === void 0 ? void 0 : site.useBannerV2);
  var contentfulApiData = cloneDeep(globalHeaderData);
  var metaCtaData = get(contentfulApiData, 'appointmentCta.dataAnalyticsValue') || (headerAnalytics === null || headerAnalytics === void 0 ? void 0 : (_headerAnalytics$anal = headerAnalytics.analyticsValue) === null || _headerAnalytics$anal === void 0 ? void 0 : _headerAnalytics$anal.GLOBAL_NAV_APPOINTMENT);
  googleTagList.push(googleTagManager.id);
  if (siteData && siteData.gtmContainerId) googleTagList.push(siteData.gtmContainerId);
  if (objectFitPolyfill) triggerWindowResize();
  var queryString = typeof window !== 'undefined' && window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var pageCompleteTittle = "".concat(pageTitle, " | ").concat(siteData && siteData.websiteName || siteData && siteData.name);
  var twitterUserName = globalFooterData !== null && globalFooterData !== void 0 && (_globalFooterData$soc = globalFooterData.socialLinks) !== null && _globalFooterData$soc !== void 0 && _globalFooterData$soc.twitterUrl ? extractTwitterHandle(globalFooterData.socialLinks.twitterUrl) : null;
  function correctPath(path) {
    var cleanPath = path.replace(/([^:]\/)\/+/g, "$1");
    cleanPath = cleanPath.replace(/blog\/blog\//g, "blog/");
    return cleanPath;
  }
  var getPageClass = function getPageClass() {
    var path = pagePath;
    while (path.slice(0, 2) === '//') {
      path = path.substr(1);
    }
    if (path === '/') {
      return "p-homepage";
    }
    var formattedPath = 'p-';
    var pathParts = path.split('/');
    var regex = new RegExp('((?:\\w+-)+\\w+)', 'gmi');
    pathParts.forEach(function (pathPart) {
      // The regex checks if p-page already exists, then adds the p-page__subpage.
      if (formattedPath.match(regex)) {
        formattedPath += '__' + pathPart;
      } else {
        // If p-page doesn't exists (p-), then adds the p-page.
        formattedPath += pathPart;
      }
    });
    return formattedPath;
  };
  return __jsx(ThemeProvider, {
    theme: themes[newtheme]
  }, __jsx(Fragment, null, __jsx("div", {
    className: "".concat(getPageClass(), " wrapper")
  }, __jsx(Head, null, __jsx("script", {
    dangerouslySetInnerHTML: {
      __html: "\n                window.dataLayer = window.dataLayer || [];\n                window.dataLayer.push({\n                  'websiteId': '".concat(site.siteId, "',\n                  'status': '").concat(site.easyEditorWebsite ? 'Easy Editor Enabled' : 'Easy Editor Disabled', "',\n                  'yextId': '").concat((site === null || site === void 0 ? void 0 : (_site$locationContact = site.locationContactInformation) === null || _site$locationContact === void 0 ? void 0 : _site$locationContact.yextIds) || 'error getting yext ID', "',\n                  'version': '4.0',\n                  'locationName': '").concat(((_site$websiteName = site.websiteName) === null || _site$websiteName === void 0 ? void 0 : _site$websiteName.replace(/[.*+?'^${}()|[\]\\]/g, '\\$&')) || '', "',\n                  'locationType': '").concat(toLower(site.websiteType), "',\n                  'locationCountry': '").concat(yextLocationCountry ? yextLocationCountry : 'Error', "',\n                  'locationAssociation': '").concat(((_site$websiteName2 = site.websiteName) === null || _site$websiteName2 === void 0 ? void 0 : _site$websiteName2.replace(/[.*+?'^${}()|[\]\\]/g, '\\$&')) || '', "',\n                  'parentOrLocation': 'TBD',\n                  'websiteTheme': '").concat(toLower(newtheme), "',\n                  'pageLanguage': '").concat(getLanguageAndLocation('en-US'), "',\n                  'socialMediaFeeds': '").concat(getSocialForAnalytics(globalFooterData && globalFooterData.socialLinks ? globalFooterData.socialLinks : ''), "',\n                  'pageTemplate':  '").concat(pageTitle && pageTitle.replace(/[.*+?'^${}()|[\]\\]/g, '\\$&'), "',\n                  'MultiLocation': '").concat((site === null || site === void 0 ? void 0 : (_site$locationContact2 = site.locationContactInformation) === null || _site$locationContact2 === void 0 ? void 0 : (_site$locationContact3 = _site$locationContact2.yextIds) === null || _site$locationContact3 === void 0 ? void 0 : _site$locationContact3.length) > 1 || false, "',\n                  'utm_source':    '").concat(urlParams.get('utm_source'), "',\n                  'utm_medium':    '").concat(urlParams.get('utm_medium'), "',\n                  'utm_campaign':  '").concat(urlParams.get('utm_campaign'), "',\n                  'utm_term':      '").concat(urlParams.get('utm_term'), "',\n                  'utm_content':   '").concat(urlParams.get('utm_content'), "',\n                  'pageTitle':     '").concat(pageTitle && pageTitle.replace(/[.*+?'^${}()|[\]\\]/g, '\\$&'), "',\n                  'PagePath':      '").concat(pagePath, "',\n                  'Referrer':      '").concat(typeof document !== 'undefined' && ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer) || '', "',\n                  'division':      '").concat(yextDivision !== undefined || yextDivision !== null ? yextDivision : 'Error', "',\n                  'mainCTA' :      '").concat(metaCtaData !== undefined ? metaCtaData : 'Error', "',\n                  'event': 'pageIsIdle'\n                });\n              ")
    }
  }), googleTagList.map(function (item, i) {
    return __jsx(Fragment, {
      key: i
    }, __jsx("link", {
      href: "".concat(googleTagManager.mainScriptSrc, "?id=").concat(item),
      rel: "preload",
      as: "script"
    }), __jsx("script", {
      dangerouslySetInnerHTML: {
        __html: "".concat(GTMsrc(googleTagManager.mainScriptSrc, item))
      }
    }));
  }), __jsx("link", {
    rel: "preconnect",
    href: "https://images.ctfassets.net"
  }), __jsx("link", {
    rel: "dns-prefetch",
    href: "https://images.ctfassets.net"
  }), __jsx("link", {
    rel: "dns-prefetch",
    href: "https://www.googletagmanager.com/"
  }), __jsx("link", {
    rel: "preconnect",
    href: "https://www.googletagmanager.com/"
  }), doNotCrawl ? __jsx("meta", {
    name: "robots",
    content: "noindex"
  }) : null, __jsx("meta", {
    name: "theme-color",
    content: themes[newtheme].button.backgroundColorPrimary
  }), __jsx("meta", {
    name: "apple-mobile-web-app-capable",
    content: "yes"
  }), __jsx("meta", {
    name: "apple-mobile-web-app-status-bar-style",
    content: themes[newtheme].button.backgroundColorPrimary
  }), __jsx("meta", {
    content: site.websiteName
  }), __jsx("meta", {
    charSet: "utf-8"
  }), pageDescription && __jsx(React.Fragment, null, __jsx("meta", {
    name: "description",
    content: pageDescription
  }), __jsx("meta", {
    property: "og:description",
    content: pageDescription
  })), ogImage && __jsx("meta", {
    property: "og:image",
    content: ogImage
  }), __jsx("title", null, pageCompleteTittle), __jsx("meta", {
    property: "og:title",
    content: pageCompleteTittle
  }), (siteData === null || siteData === void 0 ? void 0 : siteData.websiteName) && __jsx("meta", {
    property: "og:site_name",
    content: siteData === null || siteData === void 0 ? void 0 : siteData.websiteName
  }), __jsx("meta", {
    property: "og:type",
    content: "website"
  }), canonicalPagePath && __jsx("meta", {
    property: "og:url",
    content: canonicalPagePath
  }), __jsx("meta", {
    property: "og:locale",
    content: "en_US"
  }), twitterUserName && __jsx(React.Fragment, null, __jsx("meta", {
    name: "twitter:card",
    content: "summary"
  }), __jsx("meta", {
    name: "twitter:site",
    content: twitterUserName
  }), __jsx("meta", {
    name: "twitter:creator",
    content: twitterUserName
  })), siteData && siteData.favicon && __jsx("link", {
    rel: "shortcut icon",
    href: siteData.favicon.url
  }), canonicalPagePath && __jsx("link", {
    rel: "canonical",
    href: canonicalPagePath
  }), __jsx("style", {
    "data-styles": "dynamic-styles",
    dangerouslySetInnerHTML: {
      __html: dynamicStylesCss
    }
  })), __jsx("noscript", null, __jsx("img", {
    className: "gtm-noscript-hide",
    src: googleTagManager.noScriptSrc + googleTagManager.id,
    alt: ""
  })), (siteData === null || siteData === void 0 ? void 0 : siteData.gtmContainerId) && __jsx("noscript", null, __jsx("img", {
    className: "gtm-noscript-hide",
    src: googleTagManager.noScriptSrc + siteData.gtmContainerId,
    alt: ""
  })), (yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.address) && __jsx(LocalBusinessJsonLd, {
    type: "LocalBusiness",
    id: canonicalPagePath,
    name: siteData && siteData.websiteName,
    description: pageDescription,
    url: canonicalPagePath,
    telephone: yextContactInformationData && convertPhoneFormat(yextContactInformationData.mainPhone, true),
    address: (yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : yextContactInformationData.address) && {
      streetAddress: yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati = yextContactInformationData.address) === null || _yextContactInformati === void 0 ? void 0 : _yextContactInformati.line1,
      addressLocality: yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati2 = yextContactInformationData.address) === null || _yextContactInformati2 === void 0 ? void 0 : _yextContactInformati2.city,
      addressRegion: yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati3 = yextContactInformationData.address) === null || _yextContactInformati3 === void 0 ? void 0 : _yextContactInformati3.region,
      postalCode: yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati4 = yextContactInformationData.address) === null || _yextContactInformati4 === void 0 ? void 0 : _yextContactInformati4.postalCode,
      addressCountry: yextContactInformationData === null || yextContactInformationData === void 0 ? void 0 : (_yextContactInformati5 = yextContactInformationData.address) === null || _yextContactInformati5 === void 0 ? void 0 : _yextContactInformati5.countryCode
    },
    images: [(_site$logoDark = site.logoDark) === null || _site$logoDark === void 0 ? void 0 : _site$logoDark.url, (_site$logoLight = site.logoLight) === null || _site$logoLight === void 0 ? void 0 : _site$logoLight.url]
  }), contentfulAlertData && __jsx(Alert, {
    alertData: contentfulAlertData,
    className: "alert"
  }), __jsx(Anchor, {
    title: navLabels.SKIP_LINK_CONTENT,
    to: "#mainContent",
    styleType: "skip-button"
  }, navLabels.SKIP_LINK_CONTENT), showBannerV2 && __jsx(Banner, null), __jsx(HeaderWrapper, {
    site: site,
    yextContactInformationData: yextContactInformationData,
    removeHeader: removeHeader,
    globalHeaderData: globalHeaderData,
    siteData: siteData,
    newtheme: newtheme
  }), __jsx("main", {
    id: "mainContent"
  }, __jsx("h1", {
    className: "u-visually-hidden"
  }, websiteName), siteData && siteData.pencilBanner && !pencilUrlParseSite(siteData.pencilBanner.notDisplayOn, pagePath) && __jsx(PencilBanner, {
    bannerData: siteData.pencilBanner,
    className: "banner"
  }), children), (globalFooterData === null || globalFooterData === void 0 ? void 0 : globalFooterData.__typename) === 'GlobalFooter' && !removeFooter && __jsx(GlobalFooter, {
    globalFooterData: globalFooterData,
    yextContactInformationData: yextContactInformationData && yextContactInformationData,
    footerLogo: site.logoDark,
    reCaptchaKey: site.reCaptchaKey,
    themeName: newtheme
  }), (globalFooterData === null || globalFooterData === void 0 ? void 0 : globalFooterData.__typename) === 'WebsiteFooterV2' && !removeFooter && __jsx(FooterV2, {
    footer: globalFooterData,
    yextContactInformationData: yextContactInformationData && yextContactInformationData,
    footerLogo: site.logoDark,
    siteName: site.name
  })), ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true' && function () {
    //import InstantPreview from '../components/organisms/InstantPreview';
    var InstantPreview = dynamic(function () {
      return import('../components/organisms/InstantPreview');
    }, {
      ssr: false,
      loadableGenerated: {
        webpack: function webpack() {
          return [require.resolveWeak('../components/organisms/InstantPreview')];
        }
      }
    });
    return __jsx(InstantPreview, null);
  }(), siteData.audioEyeHash ? __jsx("script", {
    dangerouslySetInnerHTML: {
      __html: "\n              !function(){var b=function(){window.__AudioEyeSiteHash = \"".concat(siteData.audioEyeHash, "\"; var a=document.createElement(\"script\");a.src=\"https://wsmcdn.audioeye.com/aem.js\";a.type=\"text/javascript\";a.setAttribute(\"async\",\"\");document.getElementsByTagName(\"body\")[0].appendChild(a)};\"complete\"!==document.readyState?window.addEventListener?window.addEventListener(\"load\",b):window.attachEvent&&window.attachEvent(\"onload\",b):b()}();")
    }
  }) : null));
};
Layout.defaultProps = {
  isfooterWithoutForm: false
};
export default Layout;